import {
  FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_REQUEST,
  FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_SUCCESS,
  FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_FAILURE,
} from "./actionTypes";
import { PodDocumentState } from "./types";

const initialState: PodDocumentState = {
  podDocumentList: [],
  loading: false,
  error: null,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
        podDocumentList: [],
      };
    case FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        podDocumentList: action.payload,
        error: null,
      };
    case FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
